module.exports = __webpack_public_path__ + "img/menu-logo-close.dc1ed169.svg";